import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from './../core/services/common/common.service';
import { UrlConfig } from './../core/config/url.config';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent implements OnInit {

  constructor(private router: Router,
    public _commonService: CommonService,) { }

  ngOnInit() {
    if (localStorage.getItem('redirectUrl') == UrlConfig.quoteLiteUrl) {
      localStorage.removeItem('redirectUrl');
      localStorage.setItem('isFromQuotelite', 'True');
    }

    if (
      localStorage.getItem('IsDirectUser') == 'Yes' &&
      localStorage.getItem('IsFromWBQuote') == 'Yes'
    ) {
      //double redirection for wbquote
      localStorage.removeItem('IsFromWBQuote');
    }

    if (
      localStorage.getItem('IsDirectUser') == 'No' &&
      localStorage.getItem('IsFromWBQuote') == 'Yes'
    ) {
      //double redirection for wbquote
      localStorage.removeItem('IsFromWBQuote');
      localStorage.setItem('DirectFromWBQuote', 'True');
    }
  }

  navigateByUrl() {
    this._commonService.isTermsAccepted = true;
    localStorage.setItem('isWebApp', 'true');
    this.router.navigateByUrl('/dashboard');
  }

  cancelClick() {
    localStorage.setItem('isWebApp', 'false');
    location.href = UrlConfig.quoteLiteUrl;
  }
}
